import { debounce } from 'lodash-es'
import type { Template } from '~/api/interface'

export const useTemplateDetail = debounce(
  (
    list: Template[],
    item: Template,
    option: {
      templateSource?: TEMPLATE_SOURCE
      source?: SOURCE
    },
    changeCallback?: ([key, value]: [string, any], data: Template) => void
  ) => {
    useTemplateInit(list, item, option, changeCallback)
  },
  200
)
